  <div class="explore-detail">
    <!-- BACK BUTTON -->
    <button class="explore-detail__back" (click)="goBack()">
      <i class="pi pi-arrow-left"></i>
      {{ "socialFeed.backToExplore" | transloco }}
    </button>

    <!-- LOADING -->
    <div class="explore-detail__loading" *ngIf="loading">
      <p-progressSpinner [style]="{ width: '48px', height: '48px' }"></p-progressSpinner>
    </div>

    <!-- MAIN POST -->
    <div class="explore-detail__main" *ngIf="!loading && mainPost">
      <app-social-post-card
        [post]="mainPost"
        context="detail"
        [currentUserId]="currentUserId"
        [currentUserAvatarUrl]="currentUserAvatarUrl"
        (postChanged)="onPostChanged()"
        (reportPost)="reportDialog.open('Post', $event)"
        (reportComment)="reportDialog.open('Comment', $event)"
        (reportUser)="reportDialog.open('User', $event)"
        (projectFollowed)="onProjectFollowedFromCard($event)"
      ></app-social-post-card>
    </div>

    <!-- MORE PUBLIC POSTS -->
    <div class="explore-detail__more" *ngIf="!loading && morePosts.length">
      <h3 class="explore-detail__more-title">{{ "socialFeed.morePublicPosts" | transloco }}</h3>

      <div class="explore-detail__posts">
        <app-social-post-card
          *ngFor="let p of morePosts"
          [post]="p"
          [currentUserId]="currentUserId"
          [currentUserAvatarUrl]="currentUserAvatarUrl"
            (postChanged)="onPostChanged()"
          (reportPost)="reportDialog.open('Post', $event)"
          (reportComment)="reportDialog.open('Comment', $event)"
          (reportUser)="reportDialog.open('User', $event)"
          (projectFollowed)="onProjectFollowedFromCard($event)"
        ></app-social-post-card>
      </div>

      <div class="explore-detail__load-more" *ngIf="moreCursor">
        <button class="explore-detail__more-btn" [disabled]="loadingMore" (click)="loadMore()">
          <p-progressSpinner *ngIf="loadingMore" [style]="{ width: '20px', height: '20px' }"></p-progressSpinner>
          <span *ngIf="!loadingMore">{{ "socialFeed.loadMore" | transloco }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- REPORT DIALOG -->
  <app-social-report-dialog #reportDialog></app-social-report-dialog>
